module.exports = __webpack_public_path__ + "static/media/acto_de_grado_5.82e94b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_5.jpg
// module id = 912
// module chunks = 0